<template>
  <div class="card">
    <div class="card-content has-text-centered">
      <b-progress
        v-show="(loadedValue < 1) && !isEmpty(pdfDocument)"
        :value="loadedValue * 100"
        show-value
        format="percent"
        size="is-large"
        type="is-tertiary"
      >
      </b-progress>

      <span v-if="loadedValue > 1 && (pdfLoadingErred || isEmpty(pdfDocument))">
        {{ $t('components.signingSteps.signaturePreview.pdfLoadingFailureMessage') }}
        <!-- TODO Check if loadedValue works correct - try with loading error after complete -->
      </span>

      <section
        id="pdf-viewer"
        ref="pdfViewer"
        v-show="!(loadedValue < 1)"
      >
        <pdf
          :src="pdfDocument"
          :page="currentPage"
          @num-pages="pageCount = $event"
          @progress="loadedValue = $event"
          @error="pdfLoadingErred = true"
          @loaded="docloaded"
          @page-loaded="pgloaded"
        >
        </pdf>

        <SignatureMoveable
          v-if="pageLoaded"
          :bounds="bounds"
        />
      </section>

      <hr v-show="!(loadedValue < 1)">

      <PdfViewerControls
        v-if="showControls"
        :currentPage="currentPage"
        :pageCount="pageCount"
        @pageChanged="currentPage = $event"
      />
    </div>

    <!-- <footer class="card-footer">
      <a
        @click="confirmSignaturePosition"
        class="card-footer-item"
      >
        {{ $t('components.signingSteps.signaturePreview.buttonLabel') }}

        <b-icon icon="chevron-right">
        </b-icon>
      </a>
    </footer> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { objectUtils } from '@/mixins/objectUtils'

import PdfViewerControls from '@/components/stepper/subcomponents/PdfViewerControls.vue'
import SignatureMoveable from '@/components/stepper/subcomponents/SignatureMoveable.vue'

import pdf from 'vue-pdf'

export default {
  name: 'SignaturePreview',
  components: {
    PdfViewerControls,
    SignatureMoveable,
    pdf
  },
  mixins: [objectUtils],
  data () {
    return {
      bounds: {
        left: 0,
        top: 0,
        bottom: 0,
        right: 0
      },
      pdfDocument: {},
      currentPage: 1,
      pageCount: 1,
      loadedValue: 0,
      pageLoaded: false,
      pdfLoadingErred: false,
      showControls: false
    }
  },
  methods: {
    ...mapActions([
      'loadUploadedDocumentInfo',
      'loadDocument'
    ]),
    ...mapGetters([
      'getUploadedDocument',
      'getUploadedDocumentInfo'
    ]),
    docloaded () {
      // console.log(this.pageCount)
      // console.log('docloaded')
      this.showControls = true
      this.pdfLoadingErred = false
      // debug pdfviewer properties
    },
    pgloaded () {
      // console.log(this.pageCount)
      // console.log('pgloaded')
      this.pageLoaded = true
      localStorage.setItem('visualSigPage', this.currentPage - 1)
      // console.log(this.$refs)
      // console.log('currentPage: ', this.currentPage)
      // console.log('clientWidth: ', this.$refs.pdfViewer.clientWidth)
      // console.log('clientHeight: ', this.$refs.pdfViewer.clientHeight)
      // console.log('offsetWidth: ', this.$refs.pdfViewer.offsetWidth)
      // console.log('offsetHeight: ', this.$refs.pdfViewer.offsetHeight)
      // console.log('scrollWidth: ', this.$refs.pdfViewer.scrollWidth)
      // console.log('scrollHeight: ', this.$refs.pdfViewer.scrollHeight)
    },
    confirmSignaturePosition () {
      this.$emit('signaturePositionSelected')
    },
    downloadDocument () {
      let payload = {}
      payload.id = this.getUploadedDocumentInfo().id
      payload.signed = false

      this.loadDocument(payload)
        .then(response => {
          let downloadUrl = window.URL.createObjectURL(new Blob([response.data]))

          this.pdfDocument = downloadUrl
        })
        .catch(error => {
          // TODO: Temporary workaround for babel-transform-remove-console
          //       plugin not working.
          // eslint-disable-next-line
          console.error('GET /api/documents/' + uploadedDocumentId + '/download failed with error: ' + error.message)
        })
    },
    updateBounds () {
      let bounds = this.$refs.pdfViewer.getBoundingClientRect()

      this.bounds.top = bounds.top + document.documentElement.scrollTop
      this.bounds.bottom = this.bounds.top + this.$refs.pdfViewer.scrollHeight
      this.bounds.left = bounds.left + document.documentElement.scrollLeft
      this.bounds.right = this.bounds.left + this.$refs.pdfViewer.scrollWidth

      localStorage.setItem('bottomBoundCoord', this.bounds.bottom)
      localStorage.setItem('leftBoundCoord', this.bounds.left)
      localStorage.setItem('rightBoundCoord', this.bounds.right)
      localStorage.setItem('topBoundCoord', this.bounds.top)
    }
  },
  mounted () {
    // console.log(this.pageCount)
    this.downloadDocument()
    /* this.toBase64(this.getUploadedDocument())
      .then(response => {
        this.pdfDocument = response
      })
      .catch(error => {
        // TODO: Temporary workaround for babel-transform-remove-console
        //       plugin not working.
        // eslint-disable-next-line
        console.error('Converting the uploaded document to base64 failed with error: ', error.message)

        this.downloadDocument()
      }) */

    this.updateBounds()
  },
  updated () {
    this.updateBounds()
  },
  watch: {
    currentPage: function (value) {
      this.pageLoaded = false
    }
  }
}
</script>

<style lang="scss" scoped>
#pdf-viewer {
  position: relative;
  width: 100%;
  display: inline-block;
  border: 1px solid black;
}
</style>
